import { render } from "./svg10mAP.vue?vue&type=template&id=4d466b5a&scoped=true"
import script from "./svg10mAP.vue?vue&type=script&lang=js"
export * from "./svg10mAP.vue?vue&type=script&lang=js"

import "./svg10mAP.vue?vue&type=style&index=0&id=4d466b5a&lang=less&scoped=true"

import exportComponent from "D:\\00project\\36live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d466b5a"]])

export default __exports__